import React from 'react';
import { Link } from 'react-router-dom';
import MainButton from '../MainButton';
import styles from './styles.module.scss';

const BlogCard = ({
  image,
  title,
  date,
  category,
  color,
  item,
  edit,
  customStyle,
}: any) => {
  return (
    <div className={!edit ? styles.container : customStyle.containerEd}>
      <Link
        className={!edit ? styles.buttonLink : customStyle.buttonLinkEd}
        to={{
          pathname: !edit
            ? `/blog/${title.replace(/ /g, '')}`
            : `/blogBuilder/${title.replace(/ /g, '')}`,
        }}
        state={{ item: item }}
      >
        <div
          style={{ backgroundImage: `url(${image})` }}
          className={!edit ? styles.image : customStyle.imageEd}
        >
          <div className={!edit ? styles.button : customStyle.buttonEd}>
            <MainButton
              title={category.toUpperCase()}
              primaryColor={color}
              onClick={() => {}}
            />
          </div>
        </div>
      </Link>
      <div className={!edit ? styles.date : customStyle.dateEd}>{date}</div>
      <div className={!edit ? styles.title : customStyle.titleEd}>{title}</div>
      {!edit && (
        <Link
          className={styles.buttonLink}
          to={{
            pathname: `/blog/${title.replace(/ /g, '')}`,
          }}
          state={{ item: item }}
        >
          <div
            className={styles.readMoreButton}
            style={{ borderBottomColor: color }}
          >
            Read More
          </div>
        </Link>
      )}
    </div>
  );
};

export default BlogCard;
